import header from "./zh-CN/header";
import applications from "./zh-CN/applications";

export default {
  "navBar.lang": "语言",
  "layout.user.link.help": "帮助",
  "layout.user.link.privacy": "隐私",
  "layout.user.link.terms": "条款",
  ...header,
  ...applications,
};
